export default {
  salesOrderLines: [],
  salesOrderLine: undefined,
};
